export type AccountMetricsTotalsPayload = {
	readonly organizationCount: number;
	readonly facilityCount: number;
	readonly userCount: number;
};

export type OrganizationMetricsPayload = {
	readonly id: number;
	readonly name: string;
	readonly facilityCount: number;
	readonly userCount: number;
};

export type AccountMetricsFetchedPayload = {
	readonly totals: AccountMetricsTotalsPayload;
	readonly organizations: readonly OrganizationMetricsPayload[];
};

export type AccountMetricsFetchedAction = {
	type: 'ACCOUNT_METRICS_FETCHED';
	payload: AccountMetricsFetchedPayload;
	accountId: number;
};

export default (payload: AccountMetricsFetchedPayload, accountId: number): AccountMetricsFetchedAction => ({
	type: 'ACCOUNT_METRICS_FETCHED',
	payload,
	accountId,
});
